import * as React from "react"
import styled from 'styled-components';
import Card from 'react-bootstrap/Card';
import { Button } from "react-bootstrap";
import { useConfig } from "../../../hooks/use-config"

const StyledContainer = styled("div")`
  .card {
    width: 38rem;
    text-align: center;
    border: 0px !important;
    margin-bottom: 15px;
    /* background-color: #ffc10724 !important; */
    margin: 10px;
    border-radius: 10px;
    padding: 10px;
    box-shadow: rgb(59 59 59 / 17%) 0px 5px 10px 0px;
  }

  .card-title {
    font-weight: bold;
  }
  .accurate {
    background-color: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  }
  .afforable {
    background-color: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  }

  .lists {
    padding-bottom: 30px;
  }
  .container-width {
    max-width: 90%;
    color: #4a4560 !important;
  }

  @media (max-width: 991px) {
    .lists {
      flex-wrap: wrap !important;
    }
  }

`

const Cta = () => {

  const { clearout: clearoutConfig } = useConfig()

  return (
    <StyledContainer>
      <h2 className=" fw-bold mb-3 text-center">Let's Get Started</h2>
      <div className="d-flex justify-content-center text-center">
        <div className="container-width">
          <div className="d-flex justify-content-center lists">
            <Card className="accurate">
              <Card.Body>
                <Card.Title className="mb-4">Save Time. Work Smarter.</Card.Title>
                <Button href={clearoutConfig.app.registerUrl} target="_blank" className="btn btn-primary btn-free-credits fw-bold px-4">Try With 100 Free Credits</Button>
              </Card.Body>
            </Card>
            <Card className="afforable">
              <Card.Body>
                <Card.Title className="mb-4">Have An Enquiry?</Card.Title>
                <a href="/contact-us/">
                  <Button className="btn btn-primary btn-free-credits fw-bold px-4">Contact Us</Button>
                </a>
              </Card.Body>
            </Card>
            <Card className="afforable">
              <Card.Body>
                <Card.Title className="mb-4">Talk To An Expert.</Card.Title>
                <Button href="https://calendly.com/clearout/30min" target="_blank" className="btn btn-primary btn-free-credits fw-bold px-4">Book A Demo</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </StyledContainer>
  )
}

export default Cta;
